var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#292A2E",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M23.655 18.135a.5.5 0 0 1-.023-.148v-4.48C23.632 9.36 20.213 6 15.997 6s-7.635 3.361-7.635 7.506v4.481a.5.5 0 0 1-.022.148L7.2 21.817a.5.5 0 0 0 .478.648h16.639a.5.5 0 0 0 .477-.648z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#292A2E",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M12.405 22.465c0 1.954 1.607 3.535 3.593 3.535s3.592-1.581 3.592-3.535"
  })));
};
export default SvgBell;